var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSendNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6134 11.3292L4.11341 3.07921C3.98409 3.01453 3.83883 2.98862 3.69512 3.00459C3.55141 3.02056 3.41539 3.07772 3.30341 3.16921C3.19648 3.25883 3.11667 3.3765 3.07295 3.50899C3.02922 3.64148 3.02333 3.78355 3.05591 3.91921L5.04341 11.2467H13.5259V12.7467H5.04341L3.02591 20.0517C2.99533 20.165 2.99176 20.2839 3.01549 20.3988C3.03922 20.5137 3.08958 20.6215 3.16253 20.7134C3.23548 20.8053 3.32898 20.8788 3.43551 20.928C3.54205 20.9772 3.65864 21.0008 3.77591 20.9967C3.89332 20.996 4.00892 20.9677 4.11341 20.9142L20.6134 12.6642C20.7363 12.6013 20.8394 12.5056 20.9114 12.3879C20.9833 12.2701 21.0214 12.1347 21.0214 11.9967C21.0214 11.8587 20.9833 11.7233 20.9114 11.6055C20.8394 11.4878 20.7363 11.3921 20.6134 11.3292Z",
    fill: "#5D6679"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSendNotification);
export default __webpack_public_path__ + "static/media/ActiveSendNotification.047f0234f9d67082a0e0f8e92c65ade3.svg";
export { ForwardRef as ReactComponent };